import { render, staticRenderFns } from "./PayRangeListView.vue?vue&type=template&id=6a9b9604&scoped=true"
import script from "./PayRangeListView.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeListView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangeListView.vue?vue&type=style&index=0&id=6a9b9604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9b9604",
  null
  
)

export default component.exports